<template>
  <div v-if="voyageSolutions">
    <ThemedCheckbox
      v-model="displaySolutionsMesh"
      class="pa-0 my-0 mb-2"
      label="Show solutions mesh"
      dense
      style="width: fit-content"
      :input-value="displaySolutionsMesh"
      @click="toggleDisplaySolutionsMesh"
    />

    <v-expansion-panels
      v-model="getOpenedPanels"
      multiple
    >
      <SolutionDataPanel
        v-if="voyageSolutions.foaFeatures"
        :on-checkbox-clicked="
          () => {
            togglePanel(0);
            toggleDisplayFoa();
          }
        "
        panel-label="FOA"
        :leading-panel-data="voyageSolutions.foaVoyageStartDate"
        :trailing-panel-data="voyageSolutions.foaVoyageEndDate"
        :voyage-duration-data="voyageSolutions.foaFeatures.consumption.time"
        :consumption-data="voyageSolutions.foaFeatures.totalFuel"
        :emissions-data="voyageSolutions.foaFeatures.emissions.totalEmissions"
        :distance-data="voyageSolutions.foaFeatures.distance"
        :total-fuel-savings="voyageSolutions.foaFeatures.savings.fuelOverall"
        :time-savings="voyageSolutions.foaFeatures.savings.time"
        :model="getDisplayFoa"
        color="#757575"
      />

      <SolutionDataPanel
        v-if="voyageSolutions.minFuelFeatures"
        :on-checkbox-clicked="
          () => {
            togglePanel(1);
            toggleDisplayMinFuel();
          }
        "
        panel-label="Min Fuel"
        :leading-panel-data="voyageSolutions.minFuelVoyageStartDate"
        :trailing-panel-data="voyageSolutions.minFuelVoyageEndDate"
        :voyage-duration-data="voyageSolutions.minFuelFeatures.consumption.time"
        :consumption-data="voyageSolutions.minFuelFeatures.totalFuel"
        :emissions-data="voyageSolutions.minFuelFeatures.emissions.totalEmissions"
        :distance-data="voyageSolutions.minFuelFeatures.distance"
        :total-fuel-savings="voyageSolutions.minFuelFeatures.savings.fuelOverall"
        :time-savings="voyageSolutions.minFuelFeatures.savings.time"
        :model="getDisplayMinFuel"
        color="#66BB6A"
      />

      <SolutionDataPanel
        v-if="voyageSolutions.bestTceFeatures"
        :on-checkbox-clicked="
          () => {
            togglePanel(2);
            toggleDisplayBestTce();
          }
        "
        panel-label="Best TCE"
        :leading-panel-data="voyageSolutions.bestTceStartDate"
        :trailing-panel-data="voyageSolutions.bestTceEndDate"
        :voyage-duration-data="voyageSolutions.bestTceFeatures.consumption.time"
        :consumption-data="voyageSolutions.bestTceFeatures.totalFuel"
        :emissions-data="voyageSolutions.bestTceFeatures.emissions.totalEmissions"
        :distance-data="voyageSolutions.bestTceFeatures.distance"
        :total-fuel-savings="voyageSolutions.bestTceFeatures.savings.fuelOverall"
        :time-savings="voyageSolutions.bestTceFeatures.savings.time"
        :model="getDisplayTce"
        color="#FFA726"
      />

      <SolutionDataPanel
        v-if="voyageSolutions.minTimeFeatures"
        :on-checkbox-clicked="
          () => {
            togglePanel(3);
            toggleDisplayMinTime();
          }
        "
        panel-label="Min Time"
        :leading-panel-data="voyageSolutions.minTimeVoyageStartDate"
        :trailing-panel-data="voyageSolutions.minTimeVoyageEndDate"
        :voyage-duration-data="voyageSolutions.minTimeFeatures.consumption.time"
        :consumption-data="voyageSolutions.minTimeFeatures.totalFuel"
        :emissions-data="voyageSolutions.minTimeFeatures.emissions.totalEmissions"
        :distance-data="voyageSolutions.minTimeFeatures.distance"
        :total-fuel-savings="voyageSolutions.minTimeFeatures.savings.fuelOverall"
        :time-savings="voyageSolutions.minTimeFeatures.savings.time"
        :model="getDisplayMinTime"
        color="#F0D567"
      />

      <SolutionDataPanel
        v-if="voyageSolutions.bestDtaFeatures"
        :on-checkbox-clicked="
          () => {
            togglePanel(4);
            toggleDisplayBestDta();
          }
        "
        panel-label="Just in Time"
        :leading-panel-data="voyageSolutions.bestDtaStartDate"
        :trailing-panel-data="voyageSolutions.bestDtaEndDate"
        :voyage-duration-data="voyageSolutions.bestDtaFeatures.consumption.time"
        :consumption-data="voyageSolutions.bestDtaFeatures.totalFuel"
        :emissions-data="voyageSolutions.bestDtaFeatures.emissions.totalEmissions"
        :distance-data="voyageSolutions.bestDtaFeatures.distance"
        :total-fuel-savings="voyageSolutions.bestDtaFeatures.savings.fuelOverall"
        :time-savings="voyageSolutions.bestDtaFeatures.savings.time"
        :model="getDisplayDta"
        color="#E65100"
      />
    </v-expansion-panels>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import SolutionDataPanel from "./components/SolutionDataPanel.vue";
import ThemedCheckbox from "@/core/ThemedCheckbox.vue";

export default {
  name: "VoyageRoutesDataComponent",

  components: {
    SolutionDataPanel,
    ThemedCheckbox,
  },

  computed: {
    ...mapState("weatherRouting/voyageDetailsModule", ["voyageSolutions"]),

    ...mapGetters("weatherRouting/voyageDetailsModule", [
      "getBestDtaGeoJson",
    ]),

    ...mapState("weatherRouting/weatherRoutingMapModule", [
      "displaySolutionsMesh",
    ]),

    ...mapGetters("weatherRouting/weatherRoutingMapModule", [
      "getDisplayFoa",
      "getDisplayMinFuel",
      "getDisplayTce",
      "getDisplayDta",
      "getDisplayMinTime",
      "getOpenedPanels",
      "getBestDtaLineLayer",
      "getBestDtaPointsLayer",
    ]),
  },

  watch: {
    voyageSolutions: {
      handler(value) {
        if (!value || !value.voyageStartDate) {
          return;
        }

        this.$store.commit(
          "weatherRouting/voyageDetailsModule/SET_DATE",
          value.voyageStartDate
        );
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions("weatherRouting/weatherRoutingMapModule", [
      "toggleDisplayFoa",
      "toggleDisplayMinFuel",
      "toggleDisplayBestTce",
      "toggleDisplayBestDta",
      "toggleDisplayMinTime",
      "toggleDisplaySolutionsMesh",
      "togglePanel",
    ]),
  },
};
</script>

<style scoped>
.navigation_drawer_append {
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 80px;
}
</style>
